import * as React from 'react'
import {capitalizeFirstLetter} from '@frontrow/console/src/entities/helpers/string-helper'
import {H3} from '@frontrow/console/src/components/typography'
import {type SyncResultFailureT} from '@frontrow/console/src/entities/models/roster-sync'

type Props = {
  failure: SyncResultFailureT
}

export default function RosterSyncFailure(props: Props): React.ReactElement {
  const {failure} = props
  return (
    <React.Fragment>
      <H3>
        {`${capitalizeFirstLetter(failure.failure.severity)} `}
        in schoolId {failure.schoolIdpId}
      </H3>
      <pre>{failure.failure.message}</pre>
    </React.Fragment>
  )
}
